import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../store';

const selectState = (state: RootState): RootState['cpa'] => state.cpa;

export const selectWalletInfo = createSelector([selectState], (cpaState) => cpaState.walletInfo);

export const selectWalletInfoLoading = createSelector(
    [selectState],
    (cpaState) => cpaState.isLoading,
);

export const selectWalletAttemptCount = createSelector(
    [selectState],
    (cpaState) => cpaState.attemptCount,
);

export const selectCpaShops = createSelector([selectState], (cpaState) => cpaState.shops.items);

export const selectCpaShopsLoading = createSelector(
    [selectState],
    (cpaState) => cpaState.shops.isLoading,
);

export const selectCpaShopsSuggestLoading = createSelector(
    [selectState],
    (cpaState) => cpaState.shopsSuggest.isLoading,
);

export const selectCpaShopsSuggest = createSelector(
    [selectState],
    (cpaState) => cpaState.shopsSuggest.items,
);

export const selectCpaShopsRecomendations = createSelector(
    [selectState],
    (cpaState) => cpaState.shopsRecomendations.items,
);

export const selectCpaShopsRecomendationsLoading = createSelector(
    [selectState],
    (cpaState) => cpaState.shopsRecomendations.isLoading,
);

export const selectCpaProductsRecomendations = createSelector(
    [selectState],
    (cpaState) => cpaState.productsRecomendations.items,
);

export const selectCpaProductsRecomendationsLoading = createSelector(
    [selectState],
    (cpaState) => cpaState.productsRecomendations.isLoading,
);

export const selectCpaProducts = createSelector(
    [selectState],
    (cpaState) => cpaState.products.items,
);

export const selectCpaProductsLoading = createSelector(
    [selectState],
    (cpaState) => cpaState.products.isLoading,
);

export const selectCpaProductsSuggestLoading = createSelector(
    [selectState],
    (cpaState) => cpaState.productsSuggest.isLoading,
);

export const selectCpaProductsSuggest = createSelector(
    [selectState],
    (cpaState) => cpaState.productsSuggest.items,
);
